import React, { Component } from 'react'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import { TableComp } from 'sz-react-utils'
import moment from 'moment/moment'
import ListFollowUps from '../../../../components/_utils/listFollowUp'
import Payment from '../../../../components/_utils/payment'
import _ from 'lodash'
import { Avatar, Row, Popconfirm, Button, Card, Select, Tooltip, Input, Col, DatePicker, Checkbox, notification } from 'antd/lib/index'
import Request from '../../../../request';
import { connect } from 'react-redux'
import styles from './styles.less'
import common from '../../../common.less'
import LatestFollowUp from '../../../../components/_utils/latestFollowup'
import Settings from '../../../../components/_utils/settings'
import rightAuth from "../../../../components/_utils/userRights";
import lodash from 'lodash'
import SMS from '../../../../components/communication/sms'
import WhatsAPPSMS from '../../../../components/communication/WhatsAppSms'
import EmailDrawer from '../../../../components/communication/emailDrawer'
import { RightsWrapper } from '../../../../components/_utils/utils'
import ClickToCallDrawer from '../../../Student/inquiry/all/clickToCall'
const showDroppedLeads = rightAuth.checkUserRights('showDropLead')
const showDropLead = rightAuth.checkUserRights('dropLead')
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
let inquiryObj = {}
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
let studentObj = {};
let userCheckBox = {}
let counsellingData = {}

const Option = Select.Option
const { Search } = Input
const { RangePicker } = DatePicker

class CollapseViewCourse extends Component {
    state = {
        cp: false,
        allUsers: [],
    }

    render() {
        const { cp } = this.state
        const clondData = this.props.children
        return <React.Fragment>
            <div>
                <div className={cp ? styles.questioncollapse : styles.questioncollapsenot}>
                    {clondData && clondData.course.slice(0, cp ? (clondData.course.length) : 1).map((item) => {
                        return <ul className={styles.ul}>
                            <li><b>{item.courseName}{item.campusName && `(${item.campusName})`}</b></li>
                            <li>{item.universityInstitutionName}</li>
                            <li>
                                <small>   {item.univData && item.univData.universityCityId && `${item.univData.universityCityId.cityName} ,`}
                                    {item.univData && item.univData.universityStateId && `${item.univData.universityStateId.stateName} ,`}
                                    {item.univData && item.univData.universityCountryId && `${item.univData.universityCountryId.countryName}`}</small>
                            </li>


                        </ul>

                    })}

                </div>
                {clondData && clondData.course && clondData.course.length > 1 ?
                    <button style={{ color: 'red', float: 'right' }} onClick={() => {
                        this.setState({
                            cp: !cp
                        })
                    }}>
                        {cp ? <p>View Less - </p> : <p>View More + </p>}
                    </button> : null}
            </div>
        </React.Fragment>
    }
}

class CollapseViewStage extends Component {
    state = {
        cp: false
    }

    render() {
        const { cp } = this.state
        const clondData = this.props.children
        return <React.Fragment>
            <div>
                {clondData && clondData.course.slice(0, cp ? (clondData.course.length) : 1).map((item, index) => {
                    const { stage1, stage2 } = item
                    return (
                        <div>
                            {stage1 || stage2 ?
                                <ul className={styles.ul}>
                                    {stage2 && stage2.mailStatusDate ? <li>
                                        {
                                            item.stage2 ? <div>
                                                <b> Stage 2</b><br />
                                                <b>Offer expected :</b>
                                                <span> {stage2 && stage2.mailStatusDate ? moment(stage2.mailStatusDate).format('DD-MMM-YYYY') : null}</span>
                                                <div>{stage2.mailStatus}</div>
                                                {stage2 && stage2.offerStatus ? <div>
                                                    ---------------------
                                                    <div>
                                                        <b>Offer Detail : </b>
                                                        <div>
                                                            {stage2.offerStatus} : {stage2 && stage2.offerStatusDate ? moment(stage2.offerStatusDate).format('DD-MMM-YYYY') : null}
                                                        </div>
                                                        <div>---------------------</div>
                                                        <div><b>Fee Due Date : </b>
                                                            {stage2 && stage2.feeDueDate ? moment(stage2.feeDueDate).format('DD-MMM-YYYY') : null}
                                                        </div>


                                                    </div>
                                                </div> : null}

                                            </div> : null
                                        }
                                    </li> : <li>
                                        {
                                            item.stage1 ? <div>
                                                <b> Stage 1</b><br />
                                                <b>Application Detail:</b>
                                                <div>{stage1.status}</div>
                                            </div> : null
                                        }
                                    </li>}
                                </ul> : null
                            }
                        </div>
                    )
                })}
                {clondData && clondData.course && clondData.course.length > 1 ?
                    <button style={{ color: 'red' }} onClick={() => {
                        this.setState({
                            cp: !cp
                        })
                    }}>
                        {cp ? <p>View Less - </p> : <p>View More + </p>}
                    </button> : null}
            </div>
        </React.Fragment>
    }
}

class VisaDesk extends Component {
    state = {
        search_keyword: '',
        count: 0,
        followDuesCount: 0,
        showPayNow: false,
        showFollowUp: false,
        studentId: null,
        studentSearchId: '',
        branchId: '',
        counsellorId: '',
        counsellors: [],
        universities: [],
        universityId: '',
        allBranches: [],
        allCounsellor: [],
        deskColor: null,
        showCallDrawer: false,
        recordForCall: {},
        exportParams: {},
        showDropped: false,
        ratingArr: ['Fit2Apply', 'Potential', 'Luke Warm', 'Cold', 'Dead'],
        filesStatusList: [
            { value: 'Student Kit & Funds Requirement Issued', text: 'Student Kit & Funds Requirement Issued' },
            { value: 'Tution Fee Pending', text: 'Tution Fee Pending' },
            { value: 'Tution Fee Paid', text: 'Tution Fee Paid' },
            { value: 'COE/Receipt Pending', text: 'COE/Receipt Pending' },
            { value: 'COE/Receipt Received', text: 'COE/Receipt Received' },
            { value: 'Financial Documents Pending', text: 'Financial Documents Pending' },
            { value: 'Financial Documents Received', text: 'Financial Documents Received' },
            { value: 'Verification Pending', text: 'Verification Pending' },
            { value: 'Verification Received', text: 'Verification Received' },
            { value: 'CAQ Waiting', text: 'CAQ Waiting' },
            { value: 'GIC Waiting', text: 'GIC Waiting' },
            { value: 'Final Visa File Review', text: 'Final Visa File Review' },
            { value: 'Visa File Dispatched', text: 'Visa File Submission' }
        ],
        visaStatusList: [

            'Visa Approved',
            'Visa Refused',
            'Visa Waiting'
        ],
        userCheckBox: {},
        sourceFilterList: ['Direct', 'Associate Partner'],
        isFollowUpOverdue: false,
        allcountries: [],
        followUpsTypeList: ['Active', 'Didn\'t Pick up Call', 'Busy, Call Later', 'Not Interested', 'Out Of town', 'Cold'],
        allUsers: [],
    }

    constructor(props) {
        super(props)
        this.loadCountries()
        this.loadUniversities()
        this.table = React.createRef()
        this.followUpsCallback = this.followUpsCallback.bind(this);
        Request.getCounsellorsUsers()
            .then(resp => {
                if (resp) {
                    let temp = [{ display: '---Show All---', id: '' }];
                    resp.data = resp.data.reduce((el, vv) => {
                        vv.display = vv.name
                        vv.id = vv._id
                        temp.push(vv)
                        return temp
                    }, []);
                    this.setState({ counsellors: resp.data })
                }
            })
            .catch(err => {
            })
    }

    apiRequest = (params, columns) => {
        return new Promise(async resolve => {
            params.dropped = this.state.showDropped
            if (!params.sortField) {
                params.sortField = 'moveDeskDate.moveToVisaDesk'
                params.sortOrder = 'descend'
            }
            if (this.state.counsellorId) {
                params.counsellorId = this.state.counsellorId
                params.page = 1
            }
            if (this.state.search_keyword && this.state.search_keyword !== "") {
                params.keyword = this.state.search_keyword
            }
            if (this.state.branchId) {
                params.studentBranchId = this.state.branchId
                params.page = 1
            }
            if (this.state.studentSearchId) {
                params.studentSearchId = this.state.studentSearchId
                params.page = 1
            } else {
                params.studentSearchId = '';
            }

            params.atLevel = ['Visa Desk']
            if (this.state.status) {
                params['visaDesk.fileStatus'] = this.state.status
            }
            if (this.state.visaStatus) {
                params['visaDesk.visaStatus'] = this.state.visaStatus
            }
            if (params.dateOfBirth && params.dateOfBirth.length > 0) {
                var splitDate = params.dateOfBirth[0].split('-');
                const monthNames = ["January", "February", "March", "April", "May", "June",
                    "July", "August", "September", "October", "November", "December"
                ];
                var monthName = monthNames[splitDate[1] - 1];

                params.dateOfBirth = splitDate[0] + '-' + monthName + '-' + splitDate[2];

                const stringToDate = new Date(params.dateOfBirth);
                params.dateOfBirth = {
                    $gte: moment(params.dateOfBirth, dateFormat).startOf('day'),
                    $lt: moment(params.dateOfBirth, dateFormat).endOf('day'),
                };
            } else {
                delete params.dateOfBirth
            }

            if (this.state.isFollowUpOverdue) {
                params.isFollowUpOverdue = this.state.isFollowUpOverdue;
            }

            if (params.followUp && params.followUp.length > 0) {
                params['followUp.followUpType'] = {
                    $in: params.followUp
                };
                delete params.followUp;
            }
            if (params.preference && params.preference.length > 0) {
                params['totalPreference.country'] = {
                    $in: params.preference
                };
                delete params.preference;
            }
            if (this.state.universityId) {
                params['visaDesk.selectedCourse.universityId'] = this.state.universityId;
            }

            let data = await Request.loadCounselling({
                ...params,
                dateFilter: this.state.time,
                regExFilters: ['studentName', 'email', 'mobile', 'updatedByUser.name', 'createdByUser.name']
            })

            lodash.each(data.data, (item) => {
                if (!userCheckBox[item._id]) {
                    userCheckBox[item._id] = {
                        _id: item._id,
                        emailId: item.emailId,
                        mobile: item.mobile,
                        studentName: item.studentName,
                        isChecked: false
                    }
                }
            })

            delete data.error
            delete data.type
            this.setState({ count: data.total, followDuesCount: data.followUpsDuesCount, allBranches: data.allBranches, userCheckBox: userCheckBox, exportParams: params })
            resolve(data)
        })
    }
    closeFollowUp = () => {
        this.setState({ showFollowUp: false })
    }
    openFollowUps = record => {
        studentObj = {
            arr: record.followUp,
            name: record.studentName,
            rating: record.counsellingDesk.rating,
            subRating: record.counsellingDesk.subRating,
            _id: record._id
        }
        this.setState({ showFollowUp: true })
    }
    closePayNow = () => {
        this.setState({ showPayNow: false })
        this.table.current.reload()
    }

    closeCallDrawer = () => {
        this.setState({ showCallDrawer: false, recordForCall: {} }, () => {
            this.table.current.reload()
        })
    }

    openPayNow = record => {
        inquiryObj = {
            record: record,
            registrationDesk: record.registrationDesk,
            _id: record._id
        }
        this.setState({ showPayNow: true })
    }
    renderStatus = (val) => {

        if (val === 'Super Hot') {
            return <div className={styles.SuperHot}>{val.toUpperCase()}</div>
        }
        if (val === 'Fit2Apply') {
            return <div className={styles.Fit2Apply}>{val.toUpperCase()}</div>
        }

        if (val === 'Luke Warm') {
            return <div className={styles.LukeWarm}>{val.toUpperCase()}</div>
        }

        if (val === 'Potential') {
            return <div className={styles.Potential}>{val.toUpperCase()}</div>
        }

        if (val === 'Dead') {
            return <div className={styles.dead}>{val.toUpperCase()}</div>
        }

        if (val === 'Cold') {
            return <div className={styles.Cold}>{val.toUpperCase()}</div>
        }
    }

    followUpExtendedDate = (followUp) => {
        if (followUp && followUp.followUpDate) {
            return moment(moment(new Date()).format('YYYY-MM-DD[T00:00:00.000Z]')).isAfter(followUp.followUpDate);
        }
    }

    chooseRangerPickerApplicationDesk = (date, dateString) => {
        this.setState(
            {
                time: {
                    key: 'moveDeskDate.moveToVisaDesk',
                    from: moment(date[0]).startOf('day'),
                    to: moment(date[1]).endOf('day')
                }
            }, () => {
                if (date[0] === undefined) {
                    this.table.current.reload()
                }
            }
        )
    }

    onOk = value => {
        this.table.current.reload()
    }

    componentWillMount() {
        let searchParams = new URLSearchParams(this.props.search)
        let dateFilterByWeekOrMonth = searchParams.get('dateFilterByWeekOrMonth')
        let visaDeskDate = searchParams.get('visaDeskDate')
        let status = searchParams.get('status')
        let statusDate = searchParams.get('statusDate')
        let visaStatus = searchParams.get('visaStatus')
        let visaDeskFileStatus = searchParams.get('visaDeskFileStatus')
        if (visaDeskFileStatus) {
            if (visaDeskFileStatus === 'Student Kit ') {
                visaDeskFileStatus = 'Student Kit & Funds Requirement Issued'
                this.setState({ status: visaDeskFileStatus })
            } else {
                this.setState({ status: visaDeskFileStatus })
            }
        }

        if (statusDate) {
            this.setState({
                time: {
                    key: 'visaDesk.visaDate',
                    from: moment(statusDate, 'DD-MM-YYYY').startOf('day').toDate(),
                    to: moment(statusDate, 'DD-MM-YYYY').endOf('day').toDate(),
                },
                status: 'Visa File Dispatched'
            }, () => {
                console.log('adsffs', this.state.time, this.state.status)
            })
        }
        if (status) {
            this.setState({ status: status })

        }
        if (dateFilterByWeekOrMonth) {
            let weakStartDate = moment().startOf(`${dateFilterByWeekOrMonth}`).format()
            let weakEndDate = moment().endOf(`${dateFilterByWeekOrMonth}`).format()
            this.setState({
                time: {
                    key: 'moveDeskDate.moveToVisaDesk',
                    from: weakStartDate,
                    to: weakEndDate
                }
            }, () => {
                console.log('adsffs', this.state.time)
            })
        }

        if (visaStatus === 'Visa Waiting') {
            this.setState({ visaStatus: visaStatus })
        }

        if (visaStatus && visaDeskDate) {
            if (visaDeskDate === 'month') {
                let weakStartDate = moment().startOf('month').format()
                let weakEndDate = moment().endOf('month').format()
                this.setState({
                    time: {
                        key: 'visaDesk.submissionDate',
                        from: weakStartDate,
                        to: weakEndDate
                    }
                })
            }
            this.setState({ visaStatus: visaStatus })
        }
        this.setState({ deskColor: Settings.deskColor('Visa Desk') })
    }

    async loadCountries() {
        let { data: countriesList } = await Request.getCountriesWithoutAuth({
            results: 10000,
            businessId: activeUser && activeUser.businessId
        })
        let countryList = []
        _.each(countriesList, (item) => {
            countryList.push({ value: item.countryName, text: item.countryName })
        })
        this.setState({ allcountries: countryList })
    }
    async loadUniversities() {
        let { arr: univerityList } = await Request.loadSimpleUniversities({
            results: 10000
        })
        let universities = []
        _.each(univerityList, (item) => {
            universities.push({ id: item._id, display: item.universityInstitutionName })
        })
        this.setState({ universities: universities })
    }

    async componentDidMount() {
        window.onkeydown = function (e) {
            var ck = e.keyCode ? e.keyCode : e.which;
            if (e.ctrlKey && ck == 70) {
                if (document.querySelector('#search-student-input')) {
                    document.querySelector('#search-student-input').focus();
                }
                return false;
            } else if (ck == 27) {
                if (document.querySelector('#search-student-input')) {
                    document.querySelector('#search-student-input').focus();
                }
                return false;
            }
        }
        let { data } = await Request.loadCounsellor({
            results: 10000,
            atLevel: ['Visa Desk']
        })
        this.setState({
            allCounsellor: data, loading: false
        })
        this.loadUserBranchWise();
        this.loadFollowUpTypes()
    }

    changeSearchValue = (value) => {
        this.setState({ search_keyword: value }, () => {
            this.table.current.reload()
        })
    }

    followUpsCallback(isFollowUpOverdue) {
        this.setState({
            isFollowUpOverdue: isFollowUpOverdue,
        }, () => {
            this.table.current.reload()
        });
    }

    loadUserBranchWise = () => {
        return new Promise(async resolve => {
            let { data } = await Request.loadUserBranchWise({
                results: 10000,
                isVisa: true
            })
            this.setState({
                allUsers: data, loading: false
            })
        })
    }
    loadFollowUpTypes = async () => {
        let params = {
            results: 10000,
            count: 10000
        }
        let response = await Request.getFollowUpTypes(params)
        let followUpTypesObject = []
        _.each(response.data, (followUp) => {
            followUpTypesObject.push(followUp.name)
        })
        this.setState({ followUpsTypeList: followUpTypesObject })
    }
    showSMS = () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return item.isChecked
        })
        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            this.setState({ showSMS: true })
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }
    dropLeads = async () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return item.isChecked
        })
        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            let response = await Request.dropInquiry(counsellingData)
            if (response.success) {
                notification.success({
                    message: response.message
                })
            } else {
                notification.error({
                    message: 'Something Went Wrong'
                })
            }
            this.table.current.reload()
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }

    toggleDroppedLeads = () => {
        let showDropped = this.state.showDropped;
        showDropped = !showDropped
        this.setState({ showDropped }, () => {
            this.table.current.reload()
        })
    }
    closeSMS = () => {
        this.setState({ showSMS: false })
    }
    showWhatsAppSms = () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return (item.isChecked === true ? item : false);
        })

        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            this.setState({ showWhatsAppSms: true })
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }

    exportExcel = async () => {
        const { exportParams, count } = this.state
        exportParams.results = count
        exportParams.count = count
        // let x = await Request.exportOperationDeskToExcel({...exportParams});
        let x = await Request.exportCounsellingDeskToExcel({ ...exportParams });
        // let x = await Request.exportUsersToExcel({
        //      regExFilters: ['name'
        //     ]
        // })
        if (!x.error) {
            window.open(x.url)
        }
    }
    closeWhatsSMS = () => {
        this.setState({ showWhatsAppSms: false })
    }
    closeEmail = () => {
        this.setState({ showEmail: false })
    }
    showEmail = () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return item.isChecked
        })
        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            this.setState({ showEmail: true })
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }
    selectUser = (item, studentId) => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        if (cloneUserCheckBox[studentId] === undefined) {
            cloneUserCheckBox[studentId] = [];
        }
        cloneUserCheckBox[studentId].isChecked = !cloneUserCheckBox[studentId].isChecked
        this.setState({ userCheckBox: cloneUserCheckBox })
    }
    selectAllUserFxn = () => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        lodash.each(cloneUserCheckBox, (item) => {
            item.isChecked = true
        })
        this.setState({ userCheckBox: cloneUserCheckBox })
    }
    unselectAllUserFxn = () => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        lodash.each(cloneUserCheckBox, (item) => {
            item.isChecked = false
        })
        this.setState({ userCheckBox: cloneUserCheckBox })
    }

    render() {

        const { counsellors, universities, allBranches, allCounsellor, deskColor, filesStatusList, visaStatusList, sourceFilterList, allcountries, followUpsTypeList, allUsers } = this.state

        const columns = [
            {
                title: 'Action',
                key: 'operation',
                dataindex: 'operation',
                width: 70,
                fixed: true,
                render: (text, record) => (
                    <div className={styles.btnWrapper}>
                        <Tooltip title="Select">
                            <span className={styles.userSelectCheckbox}>
                                <Checkbox
                                    checked={userCheckBox[record._id] ? userCheckBox[record._id].isChecked : false}
                                    onChange={y => {
                                        this.selectUser(y, record._id)
                                    }}>
                                </Checkbox>
                            </span>
                        </Tooltip>&nbsp;
                        <Tooltip title="Notes">
                            <Button
                                className={styles.btn}
                                shape="circle"
                                size={'small'}
                                onClick={() => this.openFollowUps(record)}
                                icon="calendar"
                            />
                        </Tooltip>

                        <Tooltip title="Click To Edit Details">
                            <Button
                                className={styles.btn}
                                shape="circle"
                                size={'small'}
                                href={`/desk/getVisa?id=${record._id}`}
                                icon="edit"
                            />
                        </Tooltip>
                    </div>
                )
            },
            {
                title: 'VID',
                key: 'id',
                dataIndex: 'id',
                sorter: true,
                width: 120,
                fixed: true,
                searchTextName: 'id',
                filterRegex: true
            },
            {
                title: 'Student Name',
                key: 'studentName',
                dataIndex: 'studentName',
                sorter: true,
                width: 150,
                fixed: true,
                searchTextName: 'studentName',
                filterRegex: true,
                render: (item, record) => {
                    return (
                        <React.Fragment>
                            <div
                                className={
                                    this.followUpExtendedDate(record.followUp ? record.followUp : '') ? styles.followUpExtendedDate : ''
                                }
                            >
                                <Tooltip title="Click To Edit Details">
                                    <a className={styles.btn} target={'_blank'}
                                        href={`/inquiry/studentProfileDetails?id=${record._id}`}
                                    >{item}</a>
                                </Tooltip>
                            </div>
                            {
                                record.moveType === 'Application Desk - partial' ?
                                    <small style={{ background: 'red', fontSize: '12px', color: 'white', padding: '5px', marginTop: '10px', display: 'block' }}>Application moved to Visa desk partially</small>
                                    : null
                            }
                        </React.Fragment>
                    )
                }
            },
            {
                title: 'Date Of Birth',
                width: 100,
                key: 'dateOfBirth',
                dataIndex: 'dateOfBirth',
                searchTextName: `${dateFormat}`,
                render: (val, record) => {
                    return (
                        <div>
                            {record.dateOfBirth
                                ? moment(record.dateOfBirth).format(dateFormat)
                                : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Passport No',
                key: 'passportNo',
                searchTextName: 'passportNo',
                filterRegex: true,
                width: 150,
                dataIndex: 'visaDesk.passportNo'
            },
            {
                title: 'Counsellor',
                key: 'counsellorId',
                width: 120,
                filters: allCounsellor.map(x => ({ value: x._id, text: x.name })),
                render: (text, record) => {
                    return (
                        <div>{record.counsellorId ? record.counsellorId.name : ''}</div>
                    )
                }
            },
            {
                title: 'Course/University',
                key: 'counsellingDesk.course',
                width: 200,
                dataIndex: 'course',
                searchTextName: 'courseName',
                render: (text, record) => {
                    return (
                        <CollapseViewCourse>
                            {record.applicationsDesk}
                        </CollapseViewCourse>
                    )
                }
            },
            {
                title: 'Follow Up',
                key: 'followUp',
                width: 180,
                dataIndex: 'followUp',
                filters: followUpsTypeList && followUpsTypeList.map(x => ({ value: x, text: x })),
                render: (text, record) => {
                    return <LatestFollowUp info={text} />
                }
            },
            {
                title: 'Last FollowUp By',
                key: 'followUp.assignByName',
                searchTextName: 'Last FollowUp By',
                filterRegex: true,
                width: 160,
            },
            {
                title: 'Registration Details',
                key: 'registrationDesk',
                dataIndex: 'registrationDesk',
                width: 120,
                render: (item, record) => {
                    return (
                        <div>
                            {item && item.total ? <React.Fragment>Total : {item.total}<br /></React.Fragment> : ''}
                            {item && item.paid ? <React.Fragment>Paid : {item.paid}<br /></React.Fragment> : ''}
                            {item && item.balance ? <React.Fragment>Balance : {item.balance}<br /></React.Fragment> : ''}
                            {item && item.balance ? <React.Fragment>
                                <Button
                                    className={styles.btn}
                                    onClick={() => this.openPayNow(record)}
                                >Pay Now</Button>
                            </React.Fragment> : ''}
                        </div>
                    )
                }
            },
            {
                title: 'File Status',
                key: 'visaDesk.fileStatus',
                width: 80,
                filters: filesStatusList && filesStatusList.map(x => ({ value: x.value, text: x.text })),
                render: (text, record) => {
                    if (record) {
                        const { visaDesk } = record
                        if (visaDesk && visaDesk.fileStatus === 'Visa File Dispatched') {
                            return <div>
                                <div>{visaDesk && visaDesk.fileStatus === 'Visa File Dispatched' ? 'Visa File Submission' : visaDesk.fileStatus}</div>
                                <small>{visaDesk && visaDesk.visaDate ? moment(visaDesk.visaDate).format('lll') : ''}</small>
                            </div>

                        } else {
                            return <div>{visaDesk && visaDesk.fileStatus}</div>

                        }

                    } else {
                        return null
                    }
                }
            },
            {
                title: 'Visa Status',
                key: 'visaDesk.visaStatus',
                width: 80,
                filters: visaStatusList && visaStatusList.map(x => ({ value: x, text: x })),
                render: (text, record) => {
                    if (record) {
                        const { visaDesk } = record;
                        if (visaDesk.visaStatus) {
                            return (
                                <div>
                                    <div>{visaDesk && visaDesk.visaStatus ? visaDesk.visaStatus : ""}</div>
                                    <small>{visaDesk && visaDesk.visaDate ? moment(visaDesk.visaDate).format('lll') : ''}</small><br></br>
                                    <small>{record && record.updatedByUser && record.updatedByUser.name ? record.updatedByUser.name : ""}</small>
                                </div>
                            )
                        }
                    } else {
                        return null;
                    }
                }
            },
            {
                title: 'Branch',
                key: 'studentBranchId',
                filters: allBranches,
                width: 100,
                render: (text, record) => {
                    return (
                        <div>
                            {record.studentBranchId ? record.studentBranchId.branchName : ''}
                        </div>
                    )
                }
            },
            {
                title: 'MOB/WAP/Mail',
                key: 'mobwap',
                width: 110,
                dataIndex: 'mobwap',
                searchTextName: 'MOB/WAP/Mail',
                render: (val, record) => {
                    return (
                        <div>
                            <div>
                                {" "}
                                {record.mobile &&
                                    record.mobile.length >= 10 &&
                                    rightAuth.checkRights("ShowClickToCall.view") ? (
                                    <Tooltip title="Start Call">
                                        <Button
                                            className="ant-btn ant-btn-primary"
                                            onClick={() => {
                                                this.setState({ showCallDrawer: true, recordForCall: record })
                                            }}
                                        // onClick={(e) => {

                                        //   dispatch(showLoader());
                                        //   Request.callInitiate({
                                        //     mobile: record.mobile,
                                        //   }).then(({ data, error, message }) => {
                                        //     dispatch(hideLoader());
                                        //     if (!error) {
                                        //       notification.success({
                                        //         message: message,
                                        //       });
                                        //     } else {
                                        //       notification.error({
                                        //         message: message,
                                        //       });
                                        //     }
                                        //   });
                                        // }}
                                        >
                                            Click To Call
                                        </Button>
                                    </Tooltip>
                                ) : (
                                    record.mobile
                                )}
                            </div>
                            {/* <div>
                                <span>{record.mobile}</span>
                            </div> */}
                            <div>

                                {record.watsupp && record.watsupp.length === 10 ?
                                    <Tooltip title="Share on Whatsapp">
                                        <a target={'_blank'}
                                            style={{ textDecoration: 'underline' }}
                                            href={`http://api.whatsapp.com/send?phone=91${record.watsupp}&text=&source=&data=`}>{record.watsupp}</a>
                                    </Tooltip>
                                    : record.watsupp}
                            </div>
                            <div>
                                <span>{record.emailId}</span>
                            </div>
                        </div>
                    )
                }
            },
            {
                title: 'Last Updated By',
                width: 120,
                key: 'updatedByUser',
                dataIndex: 'updatedByUser',
                searchTextName: "updatedByUser",
                filterRegex: true,
                render: (text, record) => {
                    return (
                        <div>
                            <div className={common.user}>{text ? text.name : ''}</div>
                            <small>{text ? moment(text.time).format('lll') : ''}</small>
                        </div>
                    )
                }
            },
            // {
            //     title: 'Photo',
            //     key: 'profilePic',
            //     width: 60,
            //     dataIndex: 'profilePic',
            //     render: val => {
            //         return (
            //             <Avatar src={val}/>
            //         )
            //     }
            // },
            // {
            //     title: 'Offer Status',
            //     key: 'applicationsDesk',
            //     width: 200,
            //     dataIndex: 'stage',
            //     render: (text, record) => {
            //         return (
            //             <div>
            //                 <CollapseViewStage>
            //                     {record.applicationsDesk}
            //                 </CollapseViewStage>

            //             </div>
            //         )
            //     }
            // },
            // {
            //     title: 'Processed By',
            //     width: 150,
            //     filters: allUsers.map(x => ({ value: x._id, text: x.name })),
            //     key: 'processedBy',
            //     render: (text, record) => {
            //         return (
            //             <div>
            //                 {
            //                     record.applicationsDesk.course.length !== 0 ?
            //                         record.applicationsDesk.course.map((item, key) => {
            //                             return (<div>
            //                                 {item.applicationStatus.length > 0 ?
            //                                     item.applicationStatus.map((application, index) => {
            //                                         return <div>{application.status === 'Processed' ? application.processedBy : ''}</div>
            //                                     })
            //                                     : ''}
            //                             </div>)
            //                         })
            //                         : ''
            //                 }
            //             </div>
            //         )
            //     }
            // },
            // {
            //     title: 'Source',
            //     key: 'location',
            //     dataIndex: 'location',
            //     width: 100,
            //     filters: sourceFilterList && sourceFilterList.map(x => ({value: x, text: x}))
            // },
            /* {
               title: 'Rating',
               key: 'rating',
               width: 180,
               dataIndex: 'counsellingDesk.rating',
               // filters: ratingArr && ratingArr.map(x => ({value: x, text: x})),
               render: (val, record) => {
                 return this.renderStatus(val)

               }
             },*/

            // {
            //     title: 'Test Score',
            //     key: 'ieltsOverallScore',
            //     dataIndex: 'ieltsOverallScore',
            //     width: 180,
            //     render: (text, record) => {
            //         return (
            //             <div style={{fontSize: '12px'}}>
            //                 <div
            //                     style={{paddingBottom: '4px'}}> {record.testType && text ? `${record.testType} OverAll : ${text}` : null}</div>
            //                 <div
            //                     style={{paddingBottom: '4px'}}>{record && record.profile && record.profile.reading ? `Reading : ${record.profile.reading}` : null} {record && record.profile && record.profile.writing ? `Writing : ${record.profile.writing}` : null} </div>
            //                 <div>{record && record.profile && record.profile.listening ? `Listening : ${record.profile.listening}` : null} {record && record.profile && record.profile.speaking ? `Speaking : ${record.profile.speaking}` : null}</div>

            //             </div>
            //         )
            //     }
            // },
            // {
            //     title: 'Preference',
            //     key: 'preference',
            //     width: 120,
            //     filters: allcountries,
            //     render: (val, row) => {
            //         return row.totalPreference ? (
            //             <ul className={common.ul}>
            //                 {row.totalPreference.map((val, inde) => {
            //                     return <li key={inde}>{val.country}</li>
            //                 })}
            //             </ul>
            //         ) : null
            //     }
            // },


            // {
            //     title: 'Transfered Date',
            //     key: 'moveDeskDate.moveToVisaDesk',
            //     dataIndex: 'moveDeskDate.moveToVisaDesk',
            //     width: 100,
            //     render: (text, record) => {
            //         return (
            //             <div>
            //                 {text ? moment(text).format('lll') : ''}
            //             </div>
            //         )
            //     }
            // },


        ]
        return (
            <PageHeaderWrapper deskColor={deskColor} title={` VISA DESK : ${this.state.count} `} subTitle={`Follow Up Overdue : ${this.state.followDuesCount}`} followUpsCallback={this.followUpsCallback}>
                {this.state.showFollowUp ? (
                    <ListFollowUps studentObj={studentObj} onClose={this.closeFollowUp} />
                ) : null}

                {
                    this.state.showCallDrawer ?
                        <ClickToCallDrawer record={this.state.recordForCall} type="inquiry" onClose={this.closeCallDrawer} />
                        : null
                }

                {this.state.showPayNow ? (
                    <Payment inquiryObj={inquiryObj} onClose={this.closePayNow} />
                ) : null}
                <Card style={{ marginBottom: 10 }}>
                    <div className={styles.filterBlock}>
                        {/* <Col span={11}>
                            <div className={styles.myBtnGroup}>
                                {
                                    counsellors && counsellors.length ?
                                        <div style={{ display: 'flex' }}>
                                            <Col span={12}>
                                                <label>Counseller</label>
                                                <br></br>
                                                <Select
                                                    allowClear
                                                    style={{
                                                        width: '90%'

                                                    }}
                                                    showSearch={true}

                                                    value={this.state.counsellorId}
                                                    placeholder="Select Option"
                                                    optionFilterProp="display"
                                                    onChange={counsellorId => {
                                                        this.setState(
                                                            {
                                                                counsellorId: counsellorId && counsellorId.toString()
                                                            },
                                                            () => {
                                                                setTimeout(() => {
                                                                    this.table.current.reload()
                                                                }, 500);
                                                            }
                                                        );
                                                    }}>
                                                    {counsellors.map((val, idn) => {
                                                        return (
                                                            <Option key={idn} value={val.id}>
                                                                {val.display}
                                                            </Option>
                                                        )
                                                    })}
                                                </Select>
                                            </Col>
                                            <Col span={8}>
                                                <label>Vision ID</label>
                                                <br></br>
                                                <Input
                                                    allowClear
                                                    style={{
                                                        width: '90%',

                                                    }}
                                                    hidden={rightAuth.checkRights("searchStudent.view") === true ? false : true}

                                                    value={this.state.studentSearchId}
                                                    placeholder="Enter Student ID"
                                                    onChange={studentSearchId => {
                                                        this.setState(
                                                            {
                                                                studentSearchId: studentSearchId && studentSearchId.target.value
                                                            },
                                                            () => {
                                                                setTimeout(() => {
                                                                    this.table.current.reload()
                                                                }, 500);
                                                            }
                                                        );
                                                    }} />
                                            </Col>
                                        </div>
                                        : null}
                            </div>
                        </Col> */}
                        <Col span={7}>
                            <label>Filter by University</label>
                            <br></br>
                            <Select
                                allowClear
                                style={{
                                    width: '90%',

                                }}
                                showSearch={true}

                                value={this.state.universityId}
                                placeholder="Select Option"
                                optionFilterProp="display"
                                onChange={universityId => {
                                    this.setState(
                                        {
                                            universityId: universityId && universityId.toString()
                                        },
                                        () => {
                                            setTimeout(() => {
                                                this.table.current.reload()
                                            }, 500);
                                        }
                                    );
                                }}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    );
                                }}>
                                {universities.map((val, idn) => {
                                    return (
                                        <Option key={idn} value={val.id}>
                                            {val.display}
                                        </Option>
                                    )
                                })}
                            </Select>
                        </Col>
                        <Col span={6}>
                            <label>Date of Lead transfer</label>
                            <br></br>
                            <RangePicker style={{
                                maxWidth: '90%',

                            }}
                                showTime={{ format: 'HH:mm' }}
                                format="YYYY-MM-DD"
                                placeholder={['Start Date', 'End Date']}
                                onChange={this.chooseRangerPickerApplicationDesk}
                                onOk={this.onOk}
                            />
                        </Col>
                    </div>
                </Card>
                <Card style={{ marginBottom: 10 }}>
                    <Col span={4}>
                        {
                            rightAuth.checkRights("VisaDeskExcelExport.view") ?
                                <Button
                                    style={{}}
                                    onClick={() => this.exportExcel()}>
                                    Export Excel
                                </Button>
                                : null
                        }

                    </Col>
                    <div className={styles.filterBlock}>
                        <div className={styles.myBtnGroup}>
                            <div className="antd-pro-containers-student-inquiry-all-styles-myBtnGroup">
                                {
                                    showDroppedLeads || showDropLead ?
                                        <React.Fragment>
                                            <RightsWrapper myRight={"dropLead.view"}>
                                                <Popconfirm
                                                    title="Are you sure to drop this inquiry?"
                                                    onConfirm={() => {
                                                        this.dropLeads()
                                                    }}
                                                    onCancel={() => {
                                                    }}
                                                    okText="Yes"
                                                    cancelText="No"
                                                >
                                                    <Button
                                                        className={styles.btn}
                                                        type="primary">Drop Selected Leads
                                                    </Button>
                                                </Popconfirm>
                                            </RightsWrapper>
                                            <RightsWrapper myRight={"showDropLead.view"}>
                                                <Button
                                                    className={styles.btn}
                                                    type="primary"
                                                    onClick={() => {
                                                        this.toggleDroppedLeads()
                                                    }}
                                                >{this.state.showDropped ? "Show All Leads" : 'Show Dropped Leads'}
                                                </Button>
                                            </RightsWrapper>
                                        </React.Fragment>

                                        : null
                                }
                                <Button
                                    className={styles.btn}
                                    type="primary"
                                    onClick={() => this.showEmail()}>Send E-mail
                                </Button>
                                <Button
                                    type="primary"
                                    className={styles.btn}
                                    onClick={() => this.showSMS()}>Send SMS
                                </Button>
                                <Button
                                    type="primary"
                                    className={styles.btn}
                                    onClick={() => this.showWhatsAppSms()}>Whatsapp
                                </Button>
                                <Button
                                    className={styles.btn}
                                    onClick={() => this.selectAllUserFxn()}>Select Visible
                                </Button>
                                <Button
                                    className={styles.btn}
                                    onClick={() => this.unselectAllUserFxn()}>Unselect Visible
                                </Button>
                            </div>
                        </div>
                    </div>
                </Card>
                {/* {
                    showDroppedLeads || showDropLead ?
                        <Card bordered={true} style={{ marginBottom: 10 }}>
                            <Row>
                                <Col span={4}>
                                    <RightsWrapper myRight={"dropLead.view"}>
                                        <Popconfirm
                                            title="Are you sure to drop this inquiry?"
                                            onConfirm={() => {
                                                this.dropLeads()
                                            }}
                                            onCancel={() => {
                                            }}
                                            okText="Yes"
                                            cancelText="No"
                                        >
                                            <Button
                                                className={styles.btn}
                                                type="primary">Drop Selected Leads
                                            </Button>
                                        </Popconfirm>
                                    </RightsWrapper>
                                </Col>
                                <Col span={4}>
                                    <RightsWrapper myRight={"showDropLead.view"}>
                                        <Button
                                            className={styles.btn}
                                            type="primary"
                                            onClick={() => {
                                                this.toggleDroppedLeads()
                                            }}
                                        >{this.state.showDropped ? "Show All Leads" : 'Show Dropped Leads'}
                                        </Button>
                                    </RightsWrapper>
                                </Col>
                            </Row>

                        </Card>
                        : null
                } */}
                <Card bordered={true}>
                    {this.state.showWhatsAppSms ? (
                        <WhatsAPPSMS counsellingData={counsellingData} onClose={this.closeWhatsSMS} />
                    ) : null}

                    {this.state.showSMS ? (
                        <SMS counsellingData={counsellingData} onClose={this.closeSMS} />
                    ) : null}

                    {this.state.showEmail ? (
                        <EmailDrawer counsellingData={counsellingData} onClose={this.closeEmail} />
                    ) : null}
                    <Search id="search-student-input" placeholder="Search Student" onSearch={value => this.changeSearchValue(value)} enterButton />
                    <TableComp
                        columns={columns}
                        ref={this.table}
                        showSelector={true}
                        id={'visaDesk'}
                        apiRequest={this.apiRequest}
                        extraProps={{ scroll: { x: 1930 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 10,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    categories: global.categories,
    search: router.location.search

})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VisaDesk)
